




import Vue from 'vue'

export default Vue.extend({
  name: 'CommentCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.assigned ? 'check' : 'clear'
    }
  }
})
